'use strict';
var _ = require('lodash');

module.exports = {

    //Maps source properties to target properties
    //Only properties that are found in target object is maped
    //Deep mapping maps all properties from source to target,
    //regardless of wether properties are foun or not
    //target: target object
    //source: source object
    objectMerger: function (target, source) {
        var keys = _.keys(target);
        _.merge(target, _.pick(source, keys));
    },

    //Maps an array of object to the specified keys provided in config
    //sourceArray: array of objects where values will be mapped
    //config: object specifying which keys to map {sourceKeys: targetKeys}
    //valueMapperFunction: function(key, value) that returns the value for the key
    //Note: Check performance first when using it on large datas
    arrayOfObjectMapper: function (sourceArray, config, valueMapperFunction) {
        var target = [];
        for (var index in sourceArray) {
            target.push(this.ObjectMapper(sourceArray[index], config, valueMapperFunction));
        }
        return target;
    },

    //Maps source object with the provided config and value mapper
    //sourceObject: object where values will be mapped
    //config: object specifying which keys to map {sourceKeys: targetKeys, valueMapper: function(key, value)}
    //valueMapper: specify the value to set on specific keys
    //See CommonTest.js for sample
    ObjectMapper: function (sourceObject, config) {
        var targetObject = {};
        _.map(sourceObject, function (value, key) {
            if (config[key]) {
                key = config[key];
            }
            if (config.valueMapper) {
                var newValue = config.valueMapper(key, value);
                if (newValue != undefined) {
                    value = newValue;
                }
            }
            if (value !== '' && value != undefined) {
                targetObject[key] = value;
            }
        });
        return targetObject;
    },

    //Maps source object(given then specified keys in config) with the provided config and value mapper
    //sourceObject: object where values will be mapped
    //config: object specifying which keys to map {sourceKeys: targetKeys, valueMapper: function(key, value)}
    //valueMapper: specify the value to set on specific keys
    objectMapperConfigKeysOnly: function (sourceObject, config) {
        var keys = _.keys(config);
        var source = _.pick(sourceObject, keys);
        return this.ObjectMapper(source, config);
    },

    ObjectMapperConfigValuesAsKeys: function (sourceObject, config) {
        var targetObject = {};
        _.map(sourceObject, function (value, key) {
            var valueAsKey = _.findKey(config, function (v) { return v === key })
            if (valueAsKey) {
                key = valueAsKey;
            }
            targetObject[key] = value;
        });
        return targetObject;
    },

    //Returns a string from object/array values
    objectToString: function (object) {
        var string = '';
        _.map(object, function (data) {
            if (!data) {
                return null;
            }
            string = string + data;
        });
        return string;
    },

    //Converts array to {value:item<index>, label:<value>} where React-Select requires it's options to be.
    arrayToReactSelectOptions: function (options) {
        return _.map(options, function (value, index) {
            return { value: 'item' + index, label: value };
        });
    },

    getObjectByAttribute: function (list, searchParam, attributeToCheck) {
        var result = _.find(list, function (n) {
            return n[attributeToCheck] === searchParam;
        });
        return result;
    },

    getGenderTitle: function (gender, titleId, _titleList, MALE_CONSTANT, FEMALE_CONSTANT) {
        let titles;
        if (gender === MALE_CONSTANT) {
            titles = _titleList.m;
        } else if (gender === FEMALE_CONSTANT) {
            titles = _titleList.f;
        } else {
            titles = _titleList.default;
        }

        const title = _.get(_.find(titles, { 'id': parseInt(titleId, 10) }), 'name', '');
        return title;
    },


    toCurrency: function (val) {
        var numVal = val;
        if (typeof val === 'string') {
            numVal = parseFloat(val.replace(/,/g, ''));
        }
        if (isNaN(numVal)) {
            return val;
        }
        return parseFloat(numVal.toFixed(2));
    },

    toTrim: function (val) {
        return (typeof val === 'string') ? val.trim() : val;
    },

    // return default value
    defaultsTo: function(value, defaultValue) {
        return value ? value : defaultValue;
    }
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/Mapper.js